/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */

import React from 'react'
import { Link } from 'react-router-dom'
import servicesBgImg from '../assets/Images/01.jpg'
const NotFound = () => {
    return (
        <div style={{
            height: "80%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }}>

            <div style={{
                height: "60%", color: "white", backgroundImage: `url(${servicesBgImg})`, backgroundRepeat: "no-repeat",
                backgroundSize: "100%"
            }} className="container d-flex flex-column align-items-center justify-content-center" >
                <h1>404</h1>
                <h3>Page not found</h3>
                {/* <h3 style={{ border: "2px solid #2e3192" }}><Link className='text-decoration-none' to='/'>Go Back</Link></h3> */}

            </div>
        </div>
    )
}

export default NotFound

/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */